/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { defaultConfiguratorUISettingsConfig } from '../../config/default-configurator-ui-settings.config';
import { ConfiguratorAttributeQuantityComponent } from './configurator-attribute-quantity.component';
import {ItemCounterModule, KeyboardFocusModule} from "@lm-nx-frontend/lm-inf-ui";
import {I18nModule, provideDefaultConfig} from "@lm-nx-frontend/lm-inf-core";

@NgModule({
  declarations: [ConfiguratorAttributeQuantityComponent],
  exports: [ConfiguratorAttributeQuantityComponent],
  imports: [CommonModule, I18nModule, ItemCounterModule, KeyboardFocusModule],
  providers: [provideDefaultConfig(defaultConfiguratorUISettingsConfig)],
})
export class ConfiguratorAttributeQuantityModule {}
